'use client'

import { useEffect } from 'react'
import { selectDeskDocumentTitle } from '@/msgdeskRuntime/state'
import { useSubsStore } from '@/state/MsgTreeProvider'

/**
 * One title owner for every desk surface and inner route. React renders the
 * title during SSR from the boot-derived store and keeps it synchronized with
 * live model projection after hydration. The effect reasserts the React title
 * after legacy boot without changing the legacy runtime.
 */
export function DeskDocumentTitle({ runtimeAdopted }: { runtimeAdopted: boolean }) {
  const { state } = useSubsStore()
  const title = selectDeskDocumentTitle(state)

  useEffect(() => {
    document.title = title
  }, [runtimeAdopted, state.syncVersion, title])

  return <title>{title}</title>
}
